<template>
    <div class="stack">
        <div v-for="(user, index) in usersSlice" class="position-absolute" :key="user.id" :style="{'margin-left': (index * 10) + 'px', 'z-index': 100 - index}">
            <UserAvatar :user="user" :class="{'mini-avatar': users.length > 1}" :clickable="clickable && users.length == 1" @click="$emit('click')"></UserAvatar>
        </div>
    </div>
</template>

<script>

import UserAvatar from '@/components/UserAvatar.vue';

export default {
    name: 'UserAvatarStack',
    components: {
        UserAvatar
    },
    props: {
        users: {
            type: Array,
            default: () => ([]),
        },
        max: {
            type: Number,
            default: 3
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    emits: ['click'],
    computed: {
        usersSlice() {
            return (this.users && Array.isArray(this.users)) ? this.users.filter(user => user).slice(0, 3) : []
        }
    }
};

</script>

<style scoped>

.stack {
    position: relative;
    width: 3rem;
    height: 2rem;
}

.mini-avatar {
    width: 2rem;
    height: 2rem;
}

</style>
